import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner"

export function Loader({ show }) {
	if (show) {
		return (
			<div className="flex flex-center f00 mt-3">
				<FontAwesomeIcon icon={faSpinner} spin />
			</div>
		)
	}
	return null
}
